import { blogPosts as editorialPosts } from './blogData';

const PUBLISHED_BLOGS_KEY = 'qubeyards-admin-published-blogs';
const BLOG_OVERRIDES_KEY = 'qubeyards-admin-blog-overrides';
const readOverrides = () => { try { return JSON.parse(window.localStorage.getItem(BLOG_OVERRIDES_KEY) || '{}'); } catch { return {}; } };

export const readPublishedBlogs = () => {
  try {
    const value = JSON.parse(window.localStorage.getItem(PUBLISHED_BLOGS_KEY) || '[]');
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
};

export const getBlogPosts = () => { const overrides = readOverrides(); return [...readPublishedBlogs(), ...editorialPosts.map((post) => ({ ...post, ...(overrides[post.slug] || {}) }))]; };

export const publishDemoBlog = ({ title, category, excerpt, image, body }) => {
  const baseSlug = title.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'qy-journal';
  const previous = readPublishedBlogs();
  const slug = previous.some((post) => post.slug === baseSlug) || editorialPosts.some((post) => post.slug === baseSlug)
    ? `${baseSlug}-${Date.now().toString(36)}`
    : baseSlug;
  const post = {
    slug,
    title: title.trim(),
    category: category.trim().toUpperCase(),
    excerpt: excerpt.trim(),
    image: image.trim() || 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=82',
    date: new Date().toLocaleDateString('en-IN', { month: 'long', day: '2-digit', year: 'numeric' }),
    readTime: `${Math.max(1, Math.ceil(body.trim().split(/\s+/).length / 200))} min read`,
    body: body.split(/\n\s*\n/).map((paragraph) => paragraph.trim()).filter(Boolean),
    adminPublished: true,
  };
  window.localStorage.setItem(PUBLISHED_BLOGS_KEY, JSON.stringify([post, ...previous]));
  return post;
};

export const updateDemoBlog = (slug, { title, category, excerpt, image, body }) => {
  const posts = readPublishedBlogs();
  const existing = posts.find((post) => post.slug === slug) || editorialPosts.find((post) => post.slug === slug);
  if (!existing) return null;
  const updated = { ...existing, title: title.trim(), category: category.trim().toUpperCase(), excerpt: excerpt.trim(), image: image.trim() || existing.image, body: Array.isArray(body) ? body : body.split(/\n\s*\n/).map((paragraph) => paragraph.trim()).filter(Boolean), readTime: `${Math.max(1, Math.ceil((Array.isArray(body) ? body.join(' ') : body).trim().split(/\s+/).length / 200))} min read`, adminPublished: true };
  if (posts.some((post) => post.slug === slug)) window.localStorage.setItem(PUBLISHED_BLOGS_KEY, JSON.stringify(posts.map((post) => post.slug === slug ? updated : post)));
  else window.localStorage.setItem(BLOG_OVERRIDES_KEY, JSON.stringify({ ...readOverrides(), [slug]: updated }));
  return updated;
};

export const removeDemoBlog = (slug) => {
  window.localStorage.setItem(PUBLISHED_BLOGS_KEY, JSON.stringify(readPublishedBlogs().filter((post) => post.slug !== slug)));
};
